<avi-collection-data-grid
    id="tenant-usage-grid"
    class="tenant-usage-grid"
    [config]="tenantUsageGridConfig"
    gridTitle="{{ l10nKeys.headerLabel | vtranslate }}"
></avi-collection-data-grid>
